import { AuthGate } from "./auth/AuthGate.jsx";
import BusinessDashboard from "./components/BusinessDashboard.jsx";
import { CasualHome } from "./casual/CasualHome.jsx";
import { BillingStatus } from "./billing/BillingStatus.jsx";
import { BillingCallbackPage } from "./billing/BillingCallbackPage.jsx";

export default function App() {
  const path = window.location.pathname;
  const billingOutcome = path === "/billing/success" ? "success" : path === "/billing/cancel" ? "cancel" : null;

  return (
    <AuthGate>
      {({ businessUser, casualUser, activeView, setActiveView, canSwitchViews, onLogout }) => {
        if (billingOutcome) return <BillingCallbackPage outcome={billingOutcome} />;

        return (
          <div style={{ position: "relative" }}>
            <div style={{ position: "fixed", top: 10, right: 12, zIndex: 1000, display: "flex", alignItems: "center", gap: 8 }}>
              {canSwitchViews && (
                <div style={{ display: "flex", gap: 2, background: "#fff", border: "1px solid #DDD", borderRadius: 8, padding: 2 }}>
                  <button
                    onClick={() => setActiveView("business")}
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      padding: "3px 8px",
                      borderRadius: 6,
                      border: 0,
                      cursor: "pointer",
                      background: activeView === "business" ? "#735DFF" : "transparent",
                      color: activeView === "business" ? "#fff" : "#383853",
                    }}
                  >
                    Verslo
                  </button>
                  <button
                    onClick={() => setActiveView("casual")}
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      padding: "3px 8px",
                      borderRadius: 6,
                      border: 0,
                      cursor: "pointer",
                      background: activeView === "casual" ? "#735DFF" : "transparent",
                      color: activeView === "casual" ? "#fff" : "#383853",
                    }}
                  >
                    Asmeninė
                  </button>
                </div>
              )}
              {activeView === "business" && <BillingStatus />}
              <button
                onClick={onLogout}
                style={{
                  fontSize: 11,
                  color: "#383853",
                  background: "#fff",
                  border: "1px solid #DDD",
                  borderRadius: 8,
                  padding: "4px 10px",
                  cursor: "pointer",
                }}
              >
                Atsijungti
              </button>
            </div>
            {activeView === "business" && <BusinessDashboard />}
            {activeView === "casual" && <CasualHome user={casualUser} />}
          </div>
        );
      }}
    </AuthGate>
  );
}
